<div class="d-flex flex-column">
  <app-file-upload-input
    [class.d-none]="!multiple && selectedFiles?.length"
    #fileInput
    [ngModel]="selectedFiles"
    [accept]="accept"
    [inputName]="inputName"
    [controlId]="controlId"
    [multiple]="multiple && replaceFileIndex === -1"
    (selectedFilesChange)="onSelectedFilesChange($event)">
    <ng-content select="[input-copy]"></ng-content>
  </app-file-upload-input>
  <ng-content select="[input-error]"></ng-content>
  <div class="file-list" [style.margin-top.rem]="!multiple ? 0 : 1.25" *ngIf="selectedFiles?.length && !hideFileList">
    <div *ngFor="let file of selectedFiles; let i = index">
      <app-file-list-item
        action="remove"
        [fileName]="file.name"
        [fileSizeInBytes]="file.size"
        [disabled]="disabled"
        [hasError]="!!getFileError(i)"
        [previewLabel]="getPreviewLabel(i)"
        [thumbnailUrl]="getThumbnailUrl(file)"
        (removeClicked)="removeFile(file)"
        (previewClicked)="onFilePreviewClicked(file, i)" />
      <div *ngIf="getFileError(i)?.maxFileSize" class="size-error" i18n>
        <img [src]="'assets/icons/dark/Circle-Error.svg'" alt="Error" i18n-alt />
        File cannot exceed {{ maxFileSizeInMb }} MB
      </div>
    </div>
  </div>
</div>
